import { createReducer, on } from '@ngrx/store';
import { Account } from 'graphql-api/gql-api-interfaces';

import {
  resetOpenedBasket,
  setActiveBasketAccounts,
  setOpenedBasketAccounts,
} from '../actions';

export const basketAccountsFeatureKey = 'basket-accounts';

export interface State {
  /** Accounts and addresses used in opened basket */
  openedBasketAccounts: Account[];

  /** Accounts and addresses used in active basket */
  activeBasketAccounts: Account[];
}

export const initialState: State = {
  openedBasketAccounts: [],
  activeBasketAccounts: [],
};

export const reducer = createReducer(
  initialState,
  on(
    resetOpenedBasket,
    (state): State => ({ ...state, openedBasketAccounts: [] }),
  ),

  on(setOpenedBasketAccounts, (state, { basketAccounts }): State => {
    return {
      ...state,
      openedBasketAccounts: basketAccounts,
    };
  }),

  on(setActiveBasketAccounts, (state, { basketAccounts }): State => {
    return {
      ...state,
      activeBasketAccounts: basketAccounts,
    };
  }),
);
